import React from 'react';
import { string, func, bool } from 'prop-types';
import styled from 'styled-components';

const StyledBaseOption = styled.li`
  padding: 0.5em;
  transition: all 0.2s ease-in-out;

  &:hover, &.focused, &[aria-selected="true"] {
    background: #d3d3d378;
  }

  &[aria-selected="true"] {
    font-weight: bold;
  }
`;

const BaseOption = ({ label, value, onClick, name, className, selected, id }) => (
  <StyledBaseOption
    id={id}
    key={value}
    label={label}
    onClick={onClick}
    name={name}
    value={value}
    className={className}
    aria-selected={selected}
    role="option"
  >
    {label}
  </StyledBaseOption>
);

BaseOption.propTypes = {
  label: string,
  value: string,
  onClick: func,
  name: string,
  className: string,
  selected: bool,
  id: string
};

export default BaseOption;
